import { render, staticRenderFns } from "./purchase-plan.vue?vue&type=template&id=cbb1590c&scoped=true&"
import script from "./purchase-plan.vue?vue&type=script&lang=js&"
export * from "./purchase-plan.vue?vue&type=script&lang=js&"
import style0 from "./purchase-plan.vue?vue&type=style&index=0&id=cbb1590c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb1590c",
  null
  
)

export default component.exports